import styled from "styled-components";

const NotoSans14px = styled.text`
  color: #000;
  text-align: center;
  font-family: "Noto Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export default NotoSans14px;
